import { render } from "./LevelFormPage.vue?vue&type=template&id=b5598c92&ts=true"
import script from "./LevelFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./LevelFormPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/level/LevelFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b5598c92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b5598c92', __exports__)) {
    api.reload('b5598c92', __exports__)
  }
  
  module.hot.accept("./LevelFormPage.vue?vue&type=template&id=b5598c92&ts=true", () => {
    api.rerender('b5598c92', render)
  })

}


export default __exports__